import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { CourseGroupV2 } from '../api/models/Course';
import { fonts } from '../Styles';
import { MNOHSCourseTile } from './MNOHSCourseTile';

type Props = {
  /** List of course group */
  courseGroups: CourseGroupV2[];
};

/** A component for Academic Check Overview grid */
export const MNOHSAcademicGrid: React.FC<Props> = ({ courseGroups }) => {
  return (
    <View style={styles.gridContainer}>
      {courseGroups.map((group, i: number) =>
        group.courses.map((course, idx: number) => (
          <MNOHSCourseTile key={`${i}-${idx}`} course={course} courseGroup={group} onPress={() => {}} />
        ))
      )}
      <View style={styles.graduationTextContainer}>
        <Text style={styles.graduationText}>Graduation!</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  graduationTextContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  graduationText: {
    ...fonts.header1,
    fontWeight: 'bold',
  },
});
